import { render, staticRenderFns } from "./ProductsView.vue?vue&type=template&id=f8090cf6"
var script = {}
import style0 from "./ProductsView.vue?vue&type=style&index=0&id=f8090cf6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports